"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Baseline_1 = require("../model/Baseline");

var ZeroBaselineConverterImpl_1 = require("./ZeroBaselineConverterImpl");
/**
 * Zero baseline converter including transformation of "similar site" id to "site" id.
 * @author Radek Beran
 */


var ZeroBaselineWithReplacedSiteIdConverterImpl =
/*#__PURE__*/
function (_ZeroBaselineConverte) {
  _inherits(ZeroBaselineWithReplacedSiteIdConverterImpl, _ZeroBaselineConverte);

  function ZeroBaselineWithReplacedSiteIdConverterImpl(siteId, replaceBySiteId) {
    var _this;

    _classCallCheck(this, ZeroBaselineWithReplacedSiteIdConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ZeroBaselineWithReplacedSiteIdConverterImpl).call(this));
    _this.siteId = siteId;
    _this.replaceBySiteId = replaceBySiteId;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ZeroBaselineWithReplacedSiteIdConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var resultingSiteId = conversions.toClassReferenceId(source.sId);
      resultingSiteId = this.siteId && this.replaceBySiteId && resultingSiteId === this.siteId ? this.replaceBySiteId : resultingSiteId;
      return new Baseline_1.Baseline(conversions.documentToClassId(source), source.eId, conversions.toClassReferenceId(source.pId), conversions.toClassReferenceId(resultingSiteId), conversions.toDate(source.d), 0, ZeroBaselineConverterImpl_1.ZeroBaselineConverterImpl.EMPTY_FLAGS);
    }
  }]);

  return ZeroBaselineWithReplacedSiteIdConverterImpl;
}(ZeroBaselineConverterImpl_1.ZeroBaselineConverterImpl);

exports.ZeroBaselineWithReplacedSiteIdConverterImpl = ZeroBaselineWithReplacedSiteIdConverterImpl;